// Neow-style Boons: player picks 1 of 3 at run start.
// A boon is a one-shot buff applied to the player before combat begins.

import { CURSED_CARD_POOL } from './cards';

export const BOONS = [
  {
    id: 'full_send', name: 'FULL SEND', art: '🚀',
    desc: '+15 MAX HP.',
    apply: (r) => { r.player.maxHp += 15; r.player.hp += 15; },
  },
  {
    id: 'starter_pack', name: 'STARTER PACK', art: '💰',
    desc: '+100 gold.',
    apply: (r) => { r.player.gold += 100; },
  },
  {
    id: 'trim_the_slop', name: 'TRIM THE SLOP', art: '✂️',
    desc: 'Remove a starter card of your choice at next rest.',
    apply: (r) => { r.player._grantFreeRemove = (r.player._grantFreeRemove || 0) + 1; },
  },
  {
    id: 'glowup', name: 'GLOW UP', art: '✨',
    desc: 'Upgrade a random card in your deck.',
    apply: (r, rng) => {
      r.player._upgradeRandom = 1;
    },
  },
  {
    id: 'random_rare', name: 'RARE BLESSING', art: '💎',
    desc: 'Add a random RARE card to your deck.',
    apply: (r, rng) => {
      const rare = ['brainrotpower','sigmapower','brainrotbeam','sigmastare','aura','megamind','slopdunk','amplifier','delusional','chadstance','omegaslap','singularity','brainrotstorm'];
      r.player.deck.push(rare[Math.floor(rng() * rare.length)]);
    },
  },
  {
    id: 'ritual_pact', name: 'RITUAL PACT', art: '🩸',
    desc: '-15 MAX HP. Add a random CURSED card (very strong).',
    apply: (r, rng) => {
      r.player.maxHp = Math.max(20, r.player.maxHp - 15);
      r.player.hp = Math.min(r.player.hp, r.player.maxHp);
      r.player.deck.push(CURSED_CARD_POOL[Math.floor(rng() * CURSED_CARD_POOL.length)]);
    },
  },
  {
    id: 'copium_supply', name: 'COPIUM SUPPLY', art: '🧊',
    desc: 'Add 3 upgraded COPE+ cards to your deck.',
    apply: (r) => { r.player.deck.push('cope+','cope+','cope+'); },
  },
  {
    id: 'sigma_mindset', name: 'SIGMA MINDSET', art: '🧠',
    desc: 'Gain +1 permanent STR each fight (starts each combat).',
    apply: (r) => { r.player.strength = (r.player.strength || 0) + 1; },
  },
  // ==================== v0.9 NEW BOONS ====================
  {
    id: 'double_gold_rest', name: 'GOLDEN NAP', art: '💤',
    desc: 'Rest sites also give +50 gold each.',
    apply: (r) => { r.player._restGoldBonus = (r.player._restGoldBonus || 0) + 50; },
  },
  {
    id: 'upgrade_all_rare', name: 'FOIL AURA', art: '🌈',
    desc: 'Upgrade all RARE cards currently in your deck.',
    apply: (r) => { r.player._upgradeAllRare = true; },
  },
  {
    id: 'two_relics', name: 'RELIC HUNTER', art: '🗿',
    desc: 'Gain 2 random common relics.',
    apply: (r, rng) => {
      r.player._grantRandomRelics = (r.player._grantRandomRelics || 0) + 2;
    },
  },
  {
    id: 'energy_lord', name: 'ENERGY LORD', art: '⚡',
    desc: '+1 max energy. -10 max HP.',
    apply: (r) => {
      r.player.maxEnergy += 1;
      r.player.energy += 1;
      r.player.maxHp = Math.max(15, r.player.maxHp - 10);
      r.player.hp = Math.min(r.player.hp, r.player.maxHp);
    },
  },
  {
    id: 'first_kill', name: 'FIRST BLOOD', art: '🩸',
    desc: 'Deal 999 damage to the first enemy you encounter.',
    apply: (r) => { r.player._firstKill = 999; },
  },
  {
    id: 'draft_two', name: 'DRAFT TWO', art: '🎴',
    desc: 'First 3 card rewards let you pick 2 cards.',
    apply: (r) => { r.player._doubleRewards = 3; },
  },
];

// v0.9: SIGNATURE BOONS — unlocked at Mastery 5, class-specific 4th option.
export const SIGNATURE_BOONS = {
  rizzler: {
    id: 'sig_rizzler', name: 'CHARISMA OVERFLOW', art: '💋',
    desc: 'MASTERY 5 · Start every combat with +2 draw & +1 energy.',
    apply: (r) => {
      r.player._sigDraw = 2;
      r.player._sigEnergy = 1;
    },
  },
  sigma: {
    id: 'sig_sigma', name: 'GIGA GRINDSET', art: '🏋',
    desc: 'MASTERY 5 · Permanent +2 STR. -10 MAX HP.',
    apply: (r) => {
      r.player.strength = (r.player.strength || 0) + 2;
      r.player.maxHp = Math.max(20, r.player.maxHp - 10);
      r.player.hp = Math.min(r.player.hp, r.player.maxHp);
    },
  },
  gooner: {
    id: 'sig_gooner', name: 'MEATSHIELD', art: '🛡',
    desc: 'MASTERY 5 · Permanent +15 MAX HP. Start each combat with 8 block.',
    apply: (r) => {
      r.player.maxHp += 15;
      r.player.hp += 15;
      r.player._sigStartBlock = 8;
    },
  },
};

export function pickBoons(rng, n = 3, classId = null, mastery = 0) {
  const pool = [...BOONS];
  const out = [];
  for (let i = 0; i < n && pool.length; i++) {
    const idx = Math.floor(rng() * pool.length);
    out.push(pool.splice(idx, 1)[0]);
  }
  // Signature boon unlock at mastery 5+ (appended as 4th option)
  if (mastery >= 5 && classId && SIGNATURE_BOONS[classId]) {
    out.push(SIGNATURE_BOONS[classId]);
  }
  return out;
}

// Shrine offerings: sacrifice X for permanent buff this run.
export const SHRINES = [
  { id: 'shrine_hp', name: 'SHRINE OF FLESH', art: '🩸', cost: 'card', gain: 'Gain +8 MAX HP.',
    apply: (r) => { r.player.maxHp += 8; r.player.hp += 8; } },
  { id: 'shrine_gold', name: 'SHRINE OF GREED', art: '🪙', cost: 'card', gain: '+100 gold.',
    apply: (r) => { r.player.gold += 100; } },
  { id: 'shrine_upgrade', name: 'SHRINE OF ASCENSION', art: '⭐', cost: 'card', gain: 'Upgrade 2 random cards.',
    apply: (r, rng) => { r.player._upgradeRandom = (r.player._upgradeRandom || 0) + 2; } },
  { id: 'shrine_relic', name: 'SHRINE OF FORTUNE', art: '🎲', cost: 'hp10', gain: 'Gain a random relic.',
    apply: (r, rng, allRelics) => {
      const left = allRelics.filter(id => !r.player.relics.includes(id));
      if (left.length) r.player.relics.push(left[Math.floor(rng() * left.length)]);
    } },
];

// Treasure encounters: mini-puzzle "pick a chest" with variable outcomes.
// v1.9: rewards now sample from the FULL card pools (CARD_POOL_UNCOMMON / CARD_POOL_RARE)
// so players don't see the same 5 cards over and over.
import { CARD_POOL_UNCOMMON, CARD_POOL_RARE, CARD_POOL_COMMON } from './cards';

const pickCard = (pool, rng) => {
  // Prefer base cards (no + upgrade) on chest rolls to keep first-pick reads clean
  const bases = pool.filter(id => !/\+$/.test(id));
  return bases[Math.floor(rng() * bases.length)];
};

export const TREASURE_OUTCOMES = [
  { key: 'A', label: 'THE HEAVY CHEST', art: '📦', roll: (r, rng) => {
    // Big gold + random uncommon card from the FULL uncommon pool
    // v2.7 randomize gold amount in 100–200 range
    const gold = 100 + Math.floor(rng() * 100);
    r.player.gold += gold;
    const card = pickCard(CARD_POOL_UNCOMMON, rng);
    r.player.deck.push(card);
    return `+${gold} GOLD and ${card.toUpperCase()}!`;
  }},
  { key: 'B', label: 'THE SUSPICIOUS CHEST', art: '🎁', roll: (r, rng) => {
    // v2.7: three outcomes instead of two — rare / bomb / mystery neutral
    const roll = rng();
    if (roll < 0.5) {
      const card = pickCard(CARD_POOL_RARE, rng);
      r.player.deck.push(card);
      return `YOU GOT A RARE: ${card.toUpperCase()}!`;
    } else if (roll < 0.85) {
      const dmg = 10 + Math.floor(rng() * 15);
      r.player.hp = Math.max(1, r.player.hp - dmg);
      return `IT WAS A BOMB! -${dmg} HP.`;
    } else {
      // Trap-turned-treasure: MAX HP shift small
      r.player.maxHp += 5;
      r.player.hp = Math.min(r.player.maxHp, r.player.hp + 5);
      return 'IT WAS NOTHING... BUT YOU GREW STRONGER. +5 MAX HP.';
    }
  }},
  { key: 'C', label: 'THE ANCIENT CHEST', art: '🗝', roll: (r, rng, allRelics) => {
    const left = allRelics.filter(id => !r.player.relics.includes(id));
    if (left.length) {
      const relic = left[Math.floor(rng() * left.length)];
      r.player.relics.push(relic);
      return `GAINED A RELIC: ${relic.toUpperCase()}!`;
    }
    const gold = 150 + Math.floor(rng() * 100);
    r.player.gold += gold;
    return `ALREADY MAX RELICS. +${gold} GOLD INSTEAD.`;
  }},
  // v1.9: two NEW chest variants for rotation variety
  { key: 'D', label: 'THE POWER CORE', art: '🔋', roll: (r, rng) => {
    // v2.7: randomize stat delta 5–12
    const hp = 5 + Math.floor(rng() * 8);
    const gold = 40 + Math.floor(rng() * 60);
    r.player.maxHp += hp;
    r.player.hp = Math.min(r.player.maxHp, r.player.hp + hp);
    r.player.gold += gold;
    return `+${hp} MAX HP, +${hp} HP, +${gold} GOLD!`;
  }},
  { key: 'E', label: 'THE SLOP HOARD', art: '🧟', roll: (r, rng) => {
    // Two random uncommons at once — spicy pick
    const c1 = pickCard(CARD_POOL_UNCOMMON, rng);
    let c2 = pickCard(CARD_POOL_UNCOMMON, rng);
    let tries = 0;
    while (c2 === c1 && tries < 6) { c2 = pickCard(CARD_POOL_UNCOMMON, rng); tries++; }
    r.player.deck.push(c1, c2);
    return `DOUBLE UP: ${c1.toUpperCase()} + ${c2.toUpperCase()}!`;
  }},
  // v2.0 AVATARS: 3 more chest variants
  { key: 'F', label: 'THE GRIMOIRE', art: '📖', roll: (r, rng) => {
    // Random INNATE card + full heal
    const innates = ['innate_flick','innate_stance','innate_scout','innate_cope'];
    const card = innates[Math.floor(rng() * innates.length)];
    r.player.deck.push(card);
    r.player.hp = r.player.maxHp;
    return `INNATE UNLOCKED: ${card.replace('innate_','').toUpperCase()} + FULL HEAL!`;
  }},
  { key: 'G', label: 'THE AURA VAULT', art: '🔮', roll: (r, rng) => {
    // 1 rare + 30 gold
    const rare = pickCard(CARD_POOL_RARE, rng);
    r.player.deck.push(rare);
    r.player.gold += 30 + Math.floor(rng() * 40);
    return `RARE: ${rare.toUpperCase()}!`;
  }},
  { key: 'H', label: 'THE CURSED URN', art: '⚱', roll: (r, rng) => {
    // Random RARE plus a curse (net positive)
    const rare = pickCard(CARD_POOL_RARE, rng);
    const curses = ['curse_regret','curse_shame','curse_cringe','curse_doom'];
    const curse = curses[Math.floor(rng() * curses.length)];
    r.player.deck.push(rare, curse);
    return `RARE: ${rare.toUpperCase()} + CURSE: ${curse.replace('curse_','').toUpperCase()}!`;
  }},
  // v2.7: 8 NEW chest variants — dramatically expand variety so runs feel unique
  { key: 'I', label: 'THE ALGO CACHE', art: '💾', roll: (r, rng) => {
    // 3 commons at once — mass replenishment
    const c1 = pickCard(CARD_POOL_COMMON, rng);
    const c2 = pickCard(CARD_POOL_COMMON, rng);
    const c3 = pickCard(CARD_POOL_COMMON, rng);
    r.player.deck.push(c1, c2, c3);
    return `TRIPLE COMMON: ${c1.toUpperCase()}, ${c2.toUpperCase()}, ${c3.toUpperCase()}!`;
  }},
  { key: 'J', label: 'THE JACKPOT VAULT', art: '🎰', roll: (r, rng) => {
    // Pure gold windfall 250–500
    const gold = 250 + Math.floor(rng() * 250);
    r.player.gold += gold;
    return `JACKPOT! +${gold} GOLD!`;
  }},
  { key: 'K', label: 'THE HEAL WELL', art: '💧', roll: (r, rng) => {
    // Full heal + max hp bump
    const bump = 4 + Math.floor(rng() * 6);
    r.player.maxHp += bump;
    r.player.hp = r.player.maxHp;
    return `FULLY HEALED + ${bump} MAX HP!`;
  }},
  { key: 'L', label: 'THE MYSTERY CUBE', art: '🎲', roll: (r, rng, allRelics) => {
    // Random of any effect — extreme variety
    const roll = rng();
    if (roll < 0.25) {
      const c = pickCard(CARD_POOL_RARE, rng);
      r.player.deck.push(c);
      return `MYSTERY RARE: ${c.toUpperCase()}!`;
    } else if (roll < 0.5) {
      r.player.gold += 100;
      return 'MYSTERY GOLD: +100!';
    } else if (roll < 0.75) {
      r.player.maxHp += 10;
      r.player.hp += 10;
      return 'MYSTERY MIGHT: +10 MAX HP!';
    } else {
      const left = allRelics.filter(id => !r.player.relics.includes(id));
      if (left.length) {
        const rel = left[Math.floor(rng() * left.length)];
        r.player.relics.push(rel);
        return `MYSTERY RELIC: ${rel.toUpperCase()}!`;
      }
      r.player.gold += 150;
      return 'MYSTERY GOLD: +150!';
    }
  }},
  { key: 'M', label: 'THE MERCHANT SHRINE', art: '🏛', roll: (r, rng) => {
    // Big gold windfall + upgrade shard (random common upgraded)
    const gold = 75 + Math.floor(rng() * 75);
    r.player.gold += gold;
    const c = pickCard(CARD_POOL_COMMON, rng);
    r.player.deck.push(c + '+');
    return `+${gold} GOLD + UPGRADED ${c.toUpperCase()}+!`;
  }},
  { key: 'N', label: 'THE BLESSING FONT', art: '✨', roll: (r, rng) => {
    // Small permanent stat boost
    const kind = Math.floor(rng() * 3);
    if (kind === 0) {
      r.player._permaStrength = (r.player._permaStrength || 0) + 1;
      return '+1 PERMANENT STRENGTH!';
    } else if (kind === 1) {
      r.player.maxHp += 12;
      r.player.hp = Math.min(r.player.maxHp, r.player.hp + 12);
      return '+12 MAX HP FOREVER!';
    } else {
      r.player._permaDamageMult = (r.player._permaDamageMult || 1) + 0.05;
      return '+5% DAMAGE FOREVER!';
    }
  }},
  { key: 'O', label: 'THE HACKED SHELF', art: '💽', roll: (r, rng) => {
    // 1 upgraded common + 1 common
    const c1 = pickCard(CARD_POOL_COMMON, rng);
    const c2 = pickCard(CARD_POOL_COMMON, rng);
    r.player.deck.push(c1 + '+', c2);
    return `UPGRADED ${c1.toUpperCase()}+ AND ${c2.toUpperCase()}!`;
  }},
  { key: 'P', label: 'THE VOID OFFERING', art: '🕳', roll: (r, rng) => {
    // Sacrifice: lose HP for a rare + relic
    const hpLoss = 8 + Math.floor(rng() * 8);
    r.player.hp = Math.max(1, r.player.hp - hpLoss);
    const rare = pickCard(CARD_POOL_RARE, rng);
    r.player.deck.push(rare);
    return `SACRIFICED ${hpLoss} HP → ${rare.toUpperCase()}!`;
  }},
];

// v2.7: rarity-weighted chest picker so common chests appear more, mystery/jackpot rare.
// Weights: A/B/C/D/E common (60), F/G/H uncommon (30), I/J/K/L/M/N/O/P rare (15)
const CHEST_WEIGHTS = {
  A: 60, B: 60, C: 60, D: 60, E: 60,
  F: 30, G: 30, H: 30,
  I: 15, J: 12, K: 15, L: 8, M: 15, N: 8, O: 15, P: 10,
};
export function pickWeightedChest(rng, outcomes) {
  const pool = [];
  for (const o of outcomes) {
    const w = CHEST_WEIGHTS[o.key] || 20;
    for (let i = 0; i < w; i++) pool.push(o);
  }
  return pool[Math.floor(rng() * pool.length)];
}

